/** @format */

export const universityModelModule = 'sis-components.model.university';

(function () {
    initUniversityModel.$inject = ['universityModel', 'universityService'];
    universityModel.$inject = ['DS'];
    angular
        .module(universityModelModule, ['js-data', 'sis-common.university'])
        .factory('universityModel', universityModel)
        .run(initUniversityModel);

    function universityModel(DS) {
        return DS.defineResource({
            idAttribute: 'id',
            name: 'university',
            watchChanges: false,
        });
    }

    function initUniversityModel(universityModel, universityService) {
        var promised = universityService.getUniversities();
        if (promised) {
            promised.then(function (universities) {
                universityModel.inject(universities);
            });
        }
    }
})();
